module.exports = __webpack_public_path__ + "img/suesskartoffelpommes.fe7a67d8.jpg";